export const defaultConfig: Window['envs'] = {
  host: 'https://pan.sjtu.edu.cn',
  onlyPasswordLogin: false,
  selectOrgBeforeLogin: false,
  toolBox: ['fileCollect'],
  copyRight: '©2023 上海交通大学网络信息中心',
  showDownloadAppBtnInPc: true,
  loginTitleTextColor: '#FFFFFFFF',
  loginSloganTextColor: '#FFFFFFFF',
  loginMainEntrance: ['loginWithJAccount'],
  loginMoreEntrance: [],
  allowEmptyWatermarkText: true,
  showAnnouncements: true,
  logoutSSOConfig: {
urlFrom: 'server',
logoutSSOUrl: '',
target: '_self',
},
};
